import { CANVAS_TOOL_MOBILE_LIST, handler_list, pen_list } from "./constants";

export function screenFit(elementWidth, elementHeight, imageWidth, imageHeight, isWidthFit ) {
    if (isWidthFit) {
        // 폭맞춤
        const height = imageHeight * (elementWidth / imageWidth) || elementHeight;
        return { width: elementWidth , height };
    } else {
        // 쪽맞춤
        const width = imageWidth * (elementHeight / imageHeight) || elementWidth;
        return { width , height: elementHeight };
    }
}

export function getMobileToolList(currentTool) {
    let list = CANVAS_TOOL_MOBILE_LIST;
    if (handler_list.indexOf(currentTool) !== -1) {
        list[0] = currentTool;
    } else if (pen_list.indexOf(currentTool) !== -1) {
        list[1] = currentTool
    }

    return list;
}